export default "__VITE_ASSET__DAWd7m6F__"